<div class="header">
    <div class="container">
        <nav class="navbar navbar-inverse" role="navigation">
            <div class="navbar-header">
                <button type="button" (click)="navToggleClicked($event)" id="nav-toggle" class="navbar-toggle x collapsed" data-toggle="collapse" data-target="#main-nav" 
                        >
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
                <a href="#" class="navbar-brand">
                    <h1>Sää Tänään</h1>
                </a>
            </div>
            <!--/.navbar-header-->
            <div id="main-nav" class="collapse navbar-collapse"  >
                <ul class="nav navbar-nav" >
                    <li  *ngFor="let cityInformation of data ; let i = index">
                        <a (click)="cityClicked($event, i, cityInformation.dataHash)" href="{{cityInformation.dataHash}}" id="{{i}}">{{cityInformation.CityName}}</a>
                    </li> 

                </ul>
            </div>
        </nav>
        <!--/.navbar-->
    </div>
    <!--/.container-->
  </div>
  <!--/.header-->
